<template>
  <div class="nopic">
      <div>
        <p>上传时间已到，请您重新扫描二维码进入！</p>
      </div>
  </div>
</template>

<script>
import {disableBrowserBack} from "@/plugins/util";
export default {
  data(){
    return{
      isClock:false
    }
  },
  methods:{

  },
  created(){

  },
  mounted(){
    disableBrowserBack()
  }
}
</script>

<style lang="scss" scoped>
@import "./timeout.scss";

</style>